export default __webpack_public_path__ + "static/media/Back.ac1a7394.svg";